import { cx } from '../lib/cx';

/**
 * A sibling of the etrenziksmarthome.com lockup: a green outline mark, the
 * Etrenzik name in ink, and the division name in small letterspaced green
 * caps. Theirs is a house; ours is a two-mass commercial elevation, drawn at
 * the same 32px box and 2.4 stroke so the two read as one family.
 */
export default function Wordmark({ className }: { className?: string }) {
  return (
    <span className={cx('inline-flex items-center gap-2.5', className)}>
      <svg viewBox="0 0 32 32" aria-hidden="true" className="h-8 w-8 shrink-0">
        <g
          fill="none"
          stroke="var(--color-green-500)"
          strokeWidth="2.4"
          strokeLinejoin="round"
          strokeLinecap="round"
        >
          <path d="M3 27h26" />
          <path d="M6 27V14h11v13" />
          <path d="M17 27V7h9v20" />
        </g>
        <circle cx="21.5" cy="13" r="1.8" fill="var(--color-green-500)" />
      </svg>
      <span className="flex flex-col leading-none">
        <span className="text-[1.05em] font-extrabold tracking-[-0.02em] text-ink">
          Etrenzik
        </span>
        <span className="t-eyebrow mt-[0.2em] text-green-700">Design</span>
      </span>
    </span>
  );
}
